import React from 'react';
import { Checkbox } from 'components/Checkbox/Checkbox';
import Text from 'components/Text/Text';

interface IProps {
	isShowLoyaltyProgramButtons: boolean;
	toggleShowLoyaltyProgramButtons: () => void;
}

export const ShowLoyaltyProgramButtonsCheckBox: React.FC<IProps> = React.memo(
	({ isShowLoyaltyProgramButtons, toggleShowLoyaltyProgramButtons }) => (
		<Checkbox
			checked={isShowLoyaltyProgramButtons}
			testId="ShowLoyaltyProgramButtonsCheckBox"
			onChange={toggleShowLoyaltyProgramButtons}>
			<Text translationNameSpace="form" translationKey="showLoyaltyProgramButtonsLabel" />
		</Checkbox>
	),
);
